import { useContext, useEffect, useState } from "react";
import MainContext from "../context/main/mainContext";

export default function useCommonMemberAndTeamAction(itemType) {
  const mainContext = useContext(MainContext);
  const {
    member, updateMember, team, updateTeam,
  } = mainContext;

  const [isTextFollowUp, setIsTextFollowUp] = useState(false);
  const [isEmailFollowUp, setIsEmailFollowUp] = useState(false);
  const [isSendWeeklyReminder, setIsSendWeeklyReminder] = useState(false);
  const [email, setEmail] = useState("");
  const [editEmailOpen, setEditEmailOpen] = useState(false);
  const [isLcfEnabled, setIsLcfEnabled] = useState(false);

  const [isCommonActionLoading, setIsCommonActionLoading] = useState(false);
  const [isImportEnrichmentEnabled, setIsImportEnrichmentEnabled] = useState(false);

  useEffect(() => {
    if (itemType === "team") {
      setEmail(team?.team?.email);
      setIsSendWeeklyReminder(team?.team?.sendWeeklyInviteReminders);
      setIsTextFollowUp(team?.team?.textFollowUp);
      setIsEmailFollowUp(team?.team?.emailFollowUp);
      setIsImportEnrichmentEnabled(team?.team?.isImportEnrichmentEnabled ?? false);
    }
  }, [team?.team]);

  useEffect(() => {
    if (itemType === "member") {
      setEmail(member?.member?.email);
      setIsTextFollowUp(member?.member?.textFollowUp);
      setIsEmailFollowUp(member?.member?.emailFollowUp);
      setIsLcfEnabled(member?.member?.exchange !== "0");
    }
  }, [member?.member]);

  const handleUpdate = async (updateFunc, id, param) => {
    setIsCommonActionLoading(true);
    await updateFunc(id, param);
    setIsCommonActionLoading(false);
  };

  const handleUpdateMember = (param) => handleUpdate(updateMember, member?.member?.id, param);
  const handleUpdateTeam = (param) => handleUpdate(updateTeam, team?.team?.id, param);

  const handleSetEmailOpen = (state) => {
    setEmail(email);
    setEditEmailOpen(state);
  };

  const commonItems = {
    email,
    handleEmailChange: setEmail,
    isTextFollowUp,
    isEmailFollowUp,
    isCommonActionLoading,
    editEmailOpen,
    handleSetEmailOpen,
  };

  const teamItems = {
    ...commonItems,
    handleUpdateTeam,
    isSendWeeklyReminder,
    isImportEnrichmentEnabled,
    setIsImportEnrichmentEnabled,
  };

  const memberItems = {
    ...commonItems,
    isLcfEnabled,
    handleUpdateMember,
  };

  const items = {
    member: memberItems,
    team: teamItems,
  };

  return items[itemType];
}
